export function hoursMinutesValidator($el, required) {
  if (!$el.val()) return true;
  const pattern = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
  return pattern.test($el.val());
}
Foundation.Abide.defaults.validators["hoursMinutes"] = hoursMinutesValidator;
